import { Col, Row } from '@design-system/components/grid/grid';

import { Tip, TipsContainer } from './components/Tip';
import { SuperTooltipTemplate } from './types';
import { Button } from '@design-system/components/button/button';
import { resolveImagePath } from './utils';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { stepIndicator, stepIndicatorActive } from './SuperTooltipParts.css';

export const SuperTooltipTips = (p: { tips: string[] }) => {
  if (p.tips.length === 0) return null;
  return (
    <TipsContainer>
      {p.tips.map((tip, index) => (
        <Tip key={index}>{tip}</Tip>
      ))}
    </TipsContainer>
  );
};

export const CTA = (
  p: Pick<SuperTooltipTemplate, 'ctaLabel' | 'ctaLink'> & {
    onClick: (link: string) => void;
  },
) => {
  if (!p.ctaLabel) return null;
  return (
    <Col center>
      <Button
        variant="filled"
        color="primary"
        onClick={() => p.onClick(p.ctaLink)}
        style={{ marginTop: '16px' }}
      >
        {p.ctaLabel}
      </Button>
    </Col>
  );
};

export const Image = (p: { src: string; alt: string }) => {
  if (!p.src) return null;
  return (
    <img
      src={resolveImagePath(p.src)}
      alt={p.alt}
      style={{ width: 'auto', maxHeight: '300px' }}
    />
  );
};

export const InlineContent = (p: { children: string }) => {
  const parts = p.children.split(/<img src="([^"]+)">/);

  return (
    <Typography
      variant="body"
      size="large"
      fontWeight="medium"
      style={{ whiteSpace: 'pre-line' }}
    >
      <Row gap="l">
        {parts.map((part, index) => {
          if (index % 2 === 1) {
            return (
              <img
                key={index}
                src={resolveImagePath(part)}
                alt=""
                style={{ maxWidth: '112px', height: 'auto' }}
              />
            );
          }
          return part;
        })}
      </Row>
    </Typography>
  );
};

export const StepIndicator = (p: {
  totalSteps: number;
  currentStep: number;
  onClick?: (index: number) => void;
}) => {
  const { totalSteps, currentStep, onClick } = p;
  return (
    <Row gap="xs" justifyCenter alignCenter style={{ padding: '12px 0' }}>
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          onClick={() => onClick && onClick(i)}
          className={clsx(
            stepIndicator,
            currentStep === i && stepIndicatorActive,
          )}
        />
      ))}
    </Row>
  );
};
